/* eslint-disable no-undef */
/* eslint-disable camelcase */
import { createRoot } from 'react-dom/client';
import { Globals } from '@bwoty-web/ui-kit';
import GalleryView from '../shared/views/gallery/GalleryView';

const initialStateGallery = window.__INITIAL_STATE_GALLERY__;

/*
  Allow lazy load of components.
  Sets webpack publicPath for files during runtime, since the publicPath is different for each environment.
  Filepaths cannot be relative since the script is run on other domains.
*/
__webpack_public_path__ = `${initialStateGallery?.baseUrl}/static/`;
const galleryRoot = document.getElementById('gallery-view');

if (galleryRoot) {
  const root = createRoot(galleryRoot);
  root.render(
    <Globals {...initialStateGallery}>
      <GalleryView />
    </Globals>,
  );
}
